import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';
import ServicesPage from './pages/ServicesPage';
import BenefitsPage from './pages/BenefitsPage';
import PricingPage from './pages/PricingPage';
import ContactPage from './pages/ContactPage';
import ContactUsPage from './pages/ContactUsPage';
import GalleryPage from './pages/GalleryPage';
import ReviewPage, { ReviewSuccessPage } from './pages/ReviewPage';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="min-h-screen bg-slate-50 font-sans selection:bg-slate-900 selection:text-white">
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/fordele" element={<BenefitsPage />} />
          <Route path="/priser" element={<PricingPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/kontakt-os" element={<ContactUsPage />} />
          <Route path="/galleri" element={<GalleryPage />} />
          <Route path="/anmeld" element={<ReviewPage />} />
          <Route path="/anmeld/tak" element={<ReviewSuccessPage />} />
          <Route path="/service/:slug" element={<ServiceDetail />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
